import { render, staticRenderFns } from "./LoginVerification.vue?vue&type=template&id=5d5e89a8&"
import script from "./LoginVerification.vue?vue&type=script&lang=js&"
export * from "./LoginVerification.vue?vue&type=script&lang=js&"
import style0 from "./LoginVerification.vue?vue&type=style&index=0&id=5d5e89a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports